import React, { useState } from 'react';
import { AutoConfirmedAlert } from '@adjust/dashboard-components';

import { User } from '@adjust/dashboard-core/api/types';
import { SidebarId } from '@react/constants/sidebars';
import { EditUserPasswordValues } from '@react/Pages/AccountSettingsPage/UserDetails/EditUserPassword/types';
import { TraceStatus } from '@redux/types';
import { EditUserPasswordContent } from './EditUserPasswordContent';

export interface EditUserPasswordStateProps {
  trace: { status: TraceStatus; message: string };
  isAlertOpen: boolean;
  isLoading: boolean;
  user: User;
}

export interface EditUserPasswordOwnProps {
  onCancel: () => void;
}

export interface EditUserPasswordDispatchProps {
  changePassword: (params: Record<string, unknown>) => void;
  hideAlert: () => void;
}

type EditUserPasswordProps = EditUserPasswordStateProps & EditUserPasswordOwnProps & EditUserPasswordDispatchProps;

export const EditUserPassword: React.FC<EditUserPasswordProps> = ({
  onCancel,
  changePassword,
  user,
  trace,
  hideAlert,
  isAlertOpen,
  isLoading,
}) => {
  const [values, setValues] = useState<EditUserPasswordValues>({});

  const onFormSave = (values: EditUserPasswordValues) => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { new_password, confirmation, password } = values;
    const params = {
      password,
      confirmation,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      new_password,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      account_id: user.current_account_id,
      id: user.id,
    };
    setValues(values);
    changePassword(params);
  };

  const onConfirm = () => {
    hideAlert();
    if (trace.status === TraceStatus.Info) {
      onCancel();
    }
  };

  return (
    <>
      <EditUserPasswordContent values={values} isLoading={isLoading} onCancel={onCancel} onFormSave={onFormSave} />
      <AutoConfirmedAlert
        parentSidebarId={SidebarId.UserDetails}
        type={trace.status}
        isOpen={isAlertOpen}
        message={trace.message}
        onConfirm={onConfirm}
      />
    </>
  );
};
